goog.provide("shadow.js.shim.module$$tiptap$pm$state");
goog.provide("module$shadow_js_shim_module$$tiptap$pm$state");
shadow.js.shim.module$$tiptap$pm$state = shadow.js.nativeProvides["@tiptap/pm/state"] = shadow$bridge("@tiptap/pm/state");
module$shadow_js_shim_module$$tiptap$pm$state.default = shadow.js.shim.module$$tiptap$pm$state;
